import React, { FC } from 'react';

import { Icon } from 'common/components';
import { ICON_COLLECTION } from 'assets/media/icons';

import './DetailsCellRenderer.scss';

type DetailsCellRendererProps = {
    data: any;
    handleDetailsClick: (data: any) => void;
}
const DetailsCellRenderer: FC<DetailsCellRendererProps> = ({
    data,
    handleDetailsClick
}: DetailsCellRendererProps) => {
    return (
        <div className="details-cell">
            <Icon className="details-icon" title='Details' src={ICON_COLLECTION.IC_Info} onClick={() => handleDetailsClick(data)} />
        </div>
    );
};
export default DetailsCellRenderer;
